<template>
  <div class="container mt-4 mb-5">
    <div class="row">
      <div class="col-12 bread-crump-area">
        <ol>
          <li>
            <span>Home Page ▸</span>
          </li>
          <li>
            <a href="/en/">You are not authorized to access</a>
          </li>
        </ol>
      </div>
    </div>
  </div>

  <div class="container-fuild">
    <div class="container">
      <div class="row">
        <div class="col-12 page-503-message-arae">
          <section class="d-flex align-items-center justify-content-center text-center text-lg-start flex-column flex-md-row">
            <span class="mb-4  mb-md-0 "
              :style="{
                'background-image':
                  'url(' + require('/src/assets/img/fingerprint.png') + ')',
              }"
            ></span>
            <h1 >You are not authorized to access</h1>
          </section>
        </div>
      </div>
    </div>
  </div>

  <div>
    <div class="container page-503-area mb-5 mt-5">
      <div
        class="d-flex justify-content-center align-items-center -error-title"
      >
        <span>You can browse the following pages.</span>
      </div>

      <div class="row flex-wrap error-description-box">
        <div class="col-xl-3 col-lg-3 col-md col-sm col">
          <div class="card-item">
            <i class="material-icons-outlined">home </i>
            <span> Home Page </span>
            <router-link to="/">Go</router-link>
          </div>
        </div>
        <div class="col-xl-3 col-lg-3 col-md col-sm col">
          <div class="card-item">
            <i class="material-icons-outlined"> business </i>
            <span>Companies</span>
            <router-link to="/">Contact</router-link>
          </div>
        </div>
        <div class="col-xl-3 col-lg-3 col-md col-sm col">
          <div class="card-item">
            <i class="material-icons-outlined"> mail </i>
            <span>Leads</span>
            <router-link to="/">Contact</router-link>
          </div>
        </div>
        <div class="col-xl-3 col-lg-3 col-md col-sm col">
          <div class="card-item">
            <i class="material-icons-outlined"> shopping_cart </i>
            <span>Products</span>
            <router-link to="/">Review</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import pageHeader from "./Components/Thema4PageHeader.vue";
export default {
  components: {
    // pageHeader,
  },
};
</script>
<style scoped>
.page-503-message-arae{
      padding: 100px 0px;
}
.page-503-message-arae > section > span {
  width: 90px;
  height: 100px;
  display: block;
 
}
.page-503-message-arae > section > h1 {
font-size: 32px;
line-height: 40px;
display: flex;
align-items: center;
color: #323231;
padding-left: 30px;
}

.page-503-area {
  padding: 104px 0;
      background-color: #fff;
    border-radius: 25px;
}
.-error-title > span {
  /* M3/title/large */
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  line-height: 28px;
  /* identical to box height, or 127% */
  text-align: center;
  font-feature-settings: "liga" off;
  /* Color/Grey/grey-500 */
  color: var(--m3--sys--light--on-surface);
  margin-bottom: 24px;
}
.error-description-box {
  margin-top: 25px;
}
.error-description-box .card-item i {
  color: var(--m3--sys--light--primary);
  font-size: 40px;
  line-height: 40px;
}
.error-description-box .card-item span {
  /* M3/title/large */
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  line-height: 28px;
  /* identical to box height, or 127% */
  text-align: center;
  font-feature-settings: "liga" off;
  color: var(--m3--sys--light--on-surface-variant);
  margin-top: 24px;
}
.error-description-box .card-item a {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */
  text-align: center;
  letter-spacing: 0.5px;
  /* M3/sys/light/primary */
  color: var(--m3--sys--light--primary);
  margin-top: 17px;
}

.error-description-box .card-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px 15px;
  height: 280px;
  /* M3/sys/light/background */
  min-width: 250px;
  margin-bottom: 15px;
}
</style>
